import cloneDeep from 'lodash.clonedeep';
import {differenceInDays, endOfDay, format, fromUnixTime, isSameYear, isToday} from 'date-fns';
import {fr} from 'date-fns/locale';

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const isEmpty = obj => Object.keys(obj).length === 0 && obj.constructor === Object;

export const getByDotKey = (obj, key, defaultValue = null) => {
    if (obj.constructor !== Object) {
        throw new Error('getByDotKey need an object.');
    }

    let parts = key.split('.');
    return parts.reduce((acc, curr) => acc && acc[curr] ? acc[curr] : defaultValue, obj);
};

export const dataToBlob = function (data, mime) {
    data = data.split(',')[1];
    data = window.atob(data);
    let ia = new Uint8Array(data.length);
    for (var i = 0; i < data.length; i++) {
        ia[i] = data.charCodeAt(i);
    }
    return new Blob([ia], {
        type: mime
    });
};


export const setByDotKey = (obj, key, value) => {
    if (obj.constructor !== Object) {
        throw new Error('getByDotKey need an object.');
    }

    let parts = key.split('.'),
        newObj = cloneDeep(obj),
        curr = newObj;

    while (parts.length > 0) {
        let key = parts.shift();

        if (parts.length === 0) {
            curr[key] = value;
        } else if (!curr[key] || curr[key].constructor !== Object) {
            curr = curr[key] = {};
        } else {
            curr = curr[key];
        }
    }

    return newObj;
};

export const removeByDotKey = (obj, key) => {
    if (obj.constructor !== Object) {
        throw new Error('getByDotKey need an object.');
    }

    let parts = key.split('.'),
        newObj = cloneDeep(obj),
        curr = newObj;

    while (parts.length > 0) {
        let key = parts.shift();

        if (parts.length === 0) {
            delete curr[key];
        } else if (!curr[key] || curr[key].constructor !== Object) {
            return newObj;
        } else {
            curr = curr[key];
        }
    }

    return newObj;
};

export const formatDate = (unixTime) => {
    let timestamp = fromUnixTime(unixTime);
    return format(timestamp, 'dd/MM/Y');
};

export const chatFormatTime = (unixTime) => {
    let timestamp = fromUnixTime(unixTime),
        now = new Date(),
        diffInDays = differenceInDays(endOfDay(Date.now()), timestamp);

    if (isToday(timestamp)) {
        return format(timestamp, 'HH:mm');
    } else if (diffInDays === 1) {
        return 'hier';
    } else if (diffInDays < 3) {
        return diffInDays + ' jours';
    } else {
        if (isSameYear(timestamp, now)) {
            return format(timestamp, 'dd MMM', {locale: fr})
        }

        return format(timestamp, 'dd/MM/Y');
    }
};
